module.exports = __webpack_public_path__ + "static/media/vertical line 2.bb916605.svg";